export default __webpack_public_path__ + "69a37091f2858e760b5bd957e260abfa.png";